import { useEffect, useState } from "react";
import { DefaultTable } from "../../../components/table.component";
import { getReferred } from "../../../../../services/customers/customers.services";
import { Paginated } from "modules/dashboard/components/paginated.component";
import { usePagination } from "../../../hooks/usePagination";
import { rowTablePipe } from "../../../pipes/common";

const cols = [
  {
    label: "Nombres",
    property: "firstName",
    responsive: {
      state: true,
    },
  },
  {
    label: "Apellidos",
    property: "lastName",
    responsive: {
      state: true,
    },
  },
  {
    label: "Email",
    property: "email",
    responsive: {
      state: true,
    },
  },
  {
    label: "País",
    property: "countryId",
    responsive: {
      state: true,
    },
  },
  {
    label: "Teléfono",
    property: "mobile",
    responsive: {
      state: true,
    },
  },
  // {
  //   label: "Fecha Referido",
  //   property: "ibCreatedAt",
  //   responsive: {
  //     state: true,
  //   },
  // }, No hay en db
  {
    label: "Compras",
    property: "sales",
    responsive: {
      state: true,
    },
  },
];

export function ReferredTable() {
  const [referred, setReferred] = useState([]);
  const { pagination, itemsCounter, setItemsCount, changePage, changeSize } = usePagination();

  const fetchReferred = async () => {
    const result = await getReferred({ pagination });
    const rowData = rowTablePipe(result.data.items);

    setItemsCount(result.data.itemsCounter);
    setReferred(rowData);
  };

  useEffect(() => {
    fetchReferred();
  }, [pagination]);

  return (
    <>
      <DefaultTable rows={referred} cols={cols} />
      <Paginated
        itemsCounter={itemsCounter}
        pageSize={pagination.paging_size}
        currentPage={pagination.paging_index}
        changePage={changePage}
        changeSize={changeSize}
      />
    </>
  );
}
